import { useNavigate, useParams } from "react-router-dom";
import cx from "classnames";
import TimeAgo from "react-timeago";
import _ from "lodash";

import UserIcon from "../userIcon";

import styles from "./styles.module.scss";
import { DealRoomEngageChatUser } from "src/types/dealRoom";
import UserGroupIcon from "../userGroupIcon";

interface UserDetails {
  user: DealRoomEngageChatUser;
  showHighlights?: boolean;
  showOnlineStatus?: boolean;
  totalParticipants?: number
  showMembersCount?: boolean
}

const UserDetails: React.FC<UserDetails> = ({ user, showHighlights = true, showOnlineStatus = true, totalParticipants, showMembersCount = false }) => {
  const navigate = useNavigate();
  const { id, conversationId } = useParams();
  const firstName = _.get(user, 'firstName', '');
  const lastName = _.get(user, 'lastName', '');
  const userId = _.get(user, 'id', '');
  const isEveryoneChannel = isEveryoneChannelId(_.get(user,"uuid[0]",""));
  
  const isUserOnline = _.get(user, 'online', false);
  const isCurrentUser = conversationId ? `${userId}` === `${conversationId}` : false;

  const getLastActiveTime = (chatUser: DealRoomEngageChatUser) => {
    if (chatUser?.lastOnline === null) {
      return 'offline';
    }
    return (<TimeAgo date={_.get(chatUser, 'lastOnline', 0)} live={false} />)
  }


  return (
    <div
      className={cx(styles.container, {
        [styles.activeContainer]: showHighlights && isCurrentUser,
        [styles.border]: showHighlights,
      })}
      onClick={() => navigate(`/deal-room/${id}/engage/${userId}`)}>
      {_.get(user, "firstName") === "Everyone" ? <UserGroupIcon imageSrcs={[]} /> :
        <UserIcon isOnline={showOnlineStatus && isUserOnline} imageSrc={_.get(user, 'contactDTO.icon.thumbnail', '')} showOnlineStatus={showOnlineStatus} />}
      <div className={styles.rightContainer}>
        <p style={{ maxWidth: '' }} className={cx(styles.userName, styles.truncatedText, {
          [styles.active]: showHighlights && isCurrentUser,
        })}>{`${firstName ?? ''} ${lastName ?? ''}`}</p>
        {isEveryoneChannel && showMembersCount && <span className={styles.chatMembers}> {totalParticipants} members </span>}
        {!isEveryoneChannel && showOnlineStatus && <p className={styles.activityStatus}>{isUserOnline ? 'active now' : getLastActiveTime(user)}</p>}
      </div>
    </div>
  )
}

export const PlaceholderUserDetails = () => {
  return (
    <div className={styles.container}>
      <div className={cx(styles.icon, styles.block)}></div>

      <div className={styles.rightContainer}>
        <div className={cx(styles.userNameLoader, styles.block)}>{" "}</div>
        <div className={cx(styles.activityStatusLoader, styles.block)}>{" "}</div>
      </div>
    </div>
  )
}

const isEveryoneChannelId = (channelId: string): boolean =>
  /^a_[a-f0-9]+\.s_[a-f0-9]+$/.test(channelId);

export default UserDetails;